export default __webpack_public_path__ + "static/media/dimension_van.3b41a5ad.jpg";